import { render, staticRenderFns } from "./UserTagTable.vue?vue&type=template&id=040ad28f&"
import script from "./UserTagTable.vue?vue&type=script&lang=ts&"
export * from "./UserTagTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports